import React, { useContext, useEffect, useState } from "react";
import "./Welcome_Section.css";
import { AboutusAbout } from "../../../utils/apis/AboutUs/AboutUs";
import { Context } from "../../../utils/context";

const Welcome_Section = ({ abountUs, IMG_URL }) => {


  return (
    <section className="Welcome_Section">
      <div className="container">
        <div className="row align-items-center Welcome_div">
          <div className="col-lg-5 col-12">
            <div className="Welcome_img_holder">
              <img
                src={IMG_URL + abountUs?.image2}
                // src="/assets/images/about-us/welcome-img.png"
                alt="welcome-img"
                className="welcome_img"
              />
            </div>
          </div>
          <div className="col-lg-7 col-12">
            <div className="welcome_right_div">
              <div className="welcome_right_header_holder">
                <p className="welcome_title">Welcome to Infinity Ladakh Taxi</p>
                <h4 className="welcome_subtitle">
                  A travel agency with a{" "}
                  <span className="welcome_span">distinguished reputation</span>{" "}
                  for excellence.
                </h4>
              </div>

              <div className="welcome_text_div">
                <p className="welcome_text">
                  Lorem Ipsum is simply dummy text of the printing & typesetting
                  industry. Lorem Ipsum has been the industry's standard dummy
                  text ever since the 1500s, when an unknown printer took a
                  galley of type and scrambled it to make a type specimen book.
                </p>

                <p className="welcome_text">
                  Lorem Ipsum is simply dummy text of the printing & typesetting
                  industry. Lorem Ipsum has been the industry's standard dummy
                  text ever since the 1500s, when an unknown printer took a
                  galley of type and scrambled it to make a type specimen book.
                </p>
              </div>

              <div className="welcome_features_div">
                <div className="welcome_feature_holder">
                  <div className="welcome_icon_holder">
                    <img
                      src={IMG_URL + abountUs?.image2}
                      // src="/assets/images/about-us/icon-1.png "
                      className="welcome_icon"
                    />
                  </div>
                  <div className="welcome_feature_text_div">
                    <p className="blue_text">Exclusive Trip</p>
                    <p className="feature_text">
                      There are many variations of passages of available but the
                      majority.
                    </p>
                  </div>
                </div>

                <div className="welcome_feature_holder">
                  <div className="welcome_icon_holder">
                    <img
                      src="/assets/images/about-us/icon-2.png "
                      className="welcome_icon"
                    />
                  </div>
                  <div className="welcome_feature_text_div">
                    <p className="blue_text">Safety First Always</p>
                    <p className="feature_text">
                      There are many variations of passages of available but the majority.
                    </p>
                  </div>
                </div>

                <div className="welcome_feature_holder">
                  <div className="welcome_icon_holder">
                    <img
                      src="/assets/images/about-us/icon-3.png "
                      className="welcome_icon"
                    />
                  </div>
                  <div className="welcome_feature_text_div">
                    <p className="blue_text">Professional Staff</p>
                    <p className="feature_text">
                      There are many variations of passages of available but the
                      majority.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome_Section;
